import { createContext, useContext } from 'react'

import type { MagazineIssueViewEntity } from 'js/magazine-issue/View/View.types'

type MagazineViewContextValue = {
    entity: MagazineIssueViewEntity
}

const MagazineViewContext = createContext<MagazineViewContextValue | null>(null)

export const useMagazineView = () => {
    const context = useContext(MagazineViewContext)
    if (!context) {
        throw new Error(
            'useMagazineView must be used within MagazineViewProvider',
        )
    }
    return context
}

export const MagazineViewProvider = MagazineViewContext.Provider
